import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { MedicalServiceTypes } from '@/models/medicalServiceTypes';
import { SpecializationMedicalService } from '@/types/models/specializations';

export const MODULE_NAME = MedicalServiceTypes.moduleName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class MedicalServiceTypesModule extends PageBaseModule {
    constructor(module: MedicalServiceTypesModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(MedicalServiceTypes.listTitle);
        page.values.actionPagination = 'medicalServiceTypes/updatePage';
        page.values.actionPageAmountItems = 'medicalServiceTypes/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${MedicalServiceTypes.moduleName}_edit`;
        this.pageSettings.routeParam = `${MedicalServiceTypes.moduleName}Id`;
    }
    
    get items() {
        return this.pageSettings.table?.rows ?? []
    }

    get specializationItems(): SpecializationMedicalService[] {
        return this.items.map(({ id, title, isRegularConsultation }: { id: number; title: string; isRegularConsultation: boolean }) => ({
            id,
            title,
            onlyCommonPractice: isRegularConsultation,
        })).sort((a: SpecializationMedicalService, b: SpecializationMedicalService) => {
            if (a.onlyCommonPractice && !b.onlyCommonPractice) {
                return 1;
            }

            if (!a.onlyCommonPractice && b.onlyCommonPractice) {
                return -1;
            }

            return 0;
        });
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const result = await getList(MedicalServiceTypes.apiPrefix, {
                page: this.pageSettings.pageCurrent,
                items: this.pageSettings.pageAmountItems,
            });
            await this.context.dispatch('setList', result.table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(MedicalServiceTypesModule);